import React, { useState, useEffect, useRef } from 'react';
import { CustomSelect } from '../components/CustomSelect';
import { bulletins } from '../utils/Tags';
import Frame from '../components/Frame';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css'; // Import the stylesheet

const software = [	
	{ label:'Python',		url:'/_software_Python.png' },
	{ label:'ArcGIS',		url:'/_software_ArcPro.png' },
	{ label:'QGIS',			url:'/_software_QGIS.png' },
	{ label:'VBA',			url:'/_software_VBA.png' },
	{ label:'Excel',		url:'/_software_Excel.png' },
	{ label:'Outlook',		url:'/_software_Outlook.png' },
	{ label:'Powerpt',		url:'/_software_Powerpoint.png'},
	{ label:'Postgres',		url:'/_software_Postgres.png' },
];	

const bulletinData = [
	{
        "cats": ["AUT","DPR"],
		"title": "Automated Speech-to-Text Email Service",
		"img": "/_portfolio_audio_thumb.png",
		"software": ["Outlook","VBA","Python"],
        "author": "Fake Museum of History and Art",
        "date_created": "2024-01-01",
        "expiration_date": "2024-02-01",
        "text": "Event listeners in Outlook which detect incoming emails with particular sender, keyword, or attachment characteristics and trigger custom external scripts. Used in this case to detect incoming emails with an audio or video file attached or hyperlinked, run automatic speech recognition software, and respond to the email with the transcript as a text attachment.",
    },
	{
        "cats": ["AUT","DPR"],
        "title": "Automated Building Footprint Raster Conversion",
		"img": "/_portfolio_vectorize_thumb.jpg",
		"software": ["Python"],
        "author": "Fake Museum of History and Art",
        "date_created": "2024-01-01",
        "expiration_date": "2024-02-01",
        "text": "Proof-of-Concept of a workflow to efficiently export a full database of rasterized building footprints from a common property appraisal software, convert them to polygons in standard GIS formats (e.g. .geojson), properly scale and spatially position them, and append attribute data.\n\nDemonstrated ~90% cost savings over the vendor's quoted services.",
    },
	{
        "cats": ["DAN","GIS"],
        "title": "20-Year Geospatial Population Forecast",
		"img": "/_portfolio_mpo_thumb.jpg",
		"software": ["ArcGIS","Python"],
        "author": "NAICS Processing",
        "date_created": "2024-01-01",
        "expiration_date": "2024-02-01",
        "text": "Produced a geospatial forecast of population densities in the Core Area of the Matanuska-Susitna Borough ca. 2045 to support the creation of a Metropolitan Planning Organization (MPO).\n• Reviewed most recent available model (produced ~9 years prior) and identified need for new model\n• Aggregated third-party forecasts of population growth for a Steering Committee to select from\n• Distributed forecasted growth across Census Blocks based on available unbuilt, privately-owned land\n• Overlaid 4 different forecast models to define most-likely urbanized regions\n• Incorporated expert and public feedback to produce the final Metropolitan Planning Area (MPA)\n• The MPA was approved at State and Federal levels in 2023, with an estimated ~$70,000+ cost savings compared to initial estimate for data modeling",
    },
	{
        "cats": ["DAN","DBM"],
        "title": "Business License Data Clean-Up",
		"img": "/_portfolio_naics_thumb.jpg",
		"software": ["Excel","VBA","Postgres"],
        "author": "NAICS Processing",
        "date_created": "2024-01-01",
        "expiration_date": "2024-02-01",
        "text": "Cleaned data from ~10,000 active business licenses for a municipality government, to help policymakers understand the local economy and to facilitate communication with specific industries e.g. for important announcements or during distaster relief.\nThe primary task was checking and correcting owner-submitted NAICS codes, and additionally normalize name and phone number formatting using Regular Expressions. Coded a custom VBA interface to suggest likely NAICS codes based on the business name, using a NAICS Code dictionary compiled with web scraping with added custom keywords in colloquial use.",
    },
	{
        "cats": ["DBM"],
        "title": "Cairn Database",
		"img": "/_portfolio_cairn_thumb.jpg",
		"software": ["Postgres","Python"],
        "author": "Fake Museum of History and Art",
        "date_created": "2024-01-01",
        "expiration_date": "2024-02-01",
        "text": "Design and administration of a PostGIS database for a 501(c)(3) related to historical research. Designed to allow complex cross-referencing between source material, geographic features, individuals, thematic tags, and date ranges. Currently includes 116000 cited references, 1500 persons, and 4000 officially and unofficially-named geographic features. Additional features include fuzzy and phonetic name matching, duplicate image detection, and extensive scripting for efficient data input and retrieval.",
    },
	{
        "cats": ["AUT"],
		"img": "/_portfolio_slidebuilder_thumb.jpg",
		"software": ["Excel","Powerpt","VBA"],
		"frame": "",
		"btype": "EVT",
        "title": "Powerpoint Automation from Excel Dashboards",
        "author": "Choss Lore",
        "date_created": "2024-01-01",
        "expiration_date": "2024-02-01",
        "text": "Created a set of VBA scripts to generate single Powerpoint slides and/or entire presentations from an Excel workbook. Capabilities include database integration, embedding graphs, .pdf files and images, and complete control over content and styling including color themes, textboxes, tables, etc. Applied in this case to automate all aspects of complex Powerpoint presentations for quarterly technical team reviews, aside from inset maps and interpretive notes.",
    },
	{
        "cats": [""],
		"img": "/example.jpg",
		"software": ["Python","VBA"],
        "title": "Text and Image Processing Portfolio",
        "author": "NAICS Processing",
        "date_created": "2024-01-01",
        "expiration_date": "2024-02-01",
        "text": "OCR, including training, image dewarping, Experimental: AI headline extraction from historic newspapers",
    },
	{
        "cats": [""],
        "title": "Select Cartography Portfolio",
		"img": "/example.jpg",
		"software": ["Python","VBA"],
        "author": "NAICS Processing",
        "date_created": "2024-01-01",
        "expiration_date": "2024-02-01",
        "text": "including fuzzy and phonetic name matching, duplicate image detection, and ",
    },
	{
        "cats": [""],
		"title": "Bulk Metadata",
		"img": "/_portfolio_audio_thumb.png",
		"software": ["ArcGIS","Python"],
        "author": "Fake Museum of History and Art",
        "date_created": "2024-01-01",
        "expiration_date": "2024-02-01",
        "text": "Event listeners in Outlook which detect incoming emails with particular sender, keyword, or attachment characteristics and trigger custom external scripts. Used in this case to detect incoming emails with an audio or video file attached or hyperlinked, run automatic speech recognition software, and respond to the email with the transcript as a text attachment.",
    },
    // Add more bulletins as needed
];

//Used to enable line breaks in the Portfolio
const renderTextWithLineBreaks = (text) => {
  return text.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {line}
      <br />
    </React.Fragment>
  ));
};

const Portfolio = ({ currentImage, setCurrentImage }) => {
	const [pageOpacity, setPageOpacity] = useState(0); // For the new image
	const [overlayOpacity, setOverlayOpacity] = useState(1); // For the currentImage overlay
	const hasMounted = useRef(false); // Track if the component has mounted
    const [selectedTags, setSelectedTags] = useState(bulletins.filter(b => b.selected));
    const [filteredBulletins, setFilteredBulletins] = useState([]);
    const [isIframeLoaded, setIsIframeLoaded] = useState(false);


    useEffect(() => {
        // Sorting disabled
        const sortedBulletins = [...bulletinData] //.sort((a, b) => new Date(b.date_created) - new Date(a.date_created));
        // Filter bulletins by selectedTags
        const filtered = sortedBulletins.filter(bulletin => 
			bulletin.cats.some(cat => selectedTags.some(tag => tag.tag === cat))
		);
        setFilteredBulletins(filtered);
    }, [selectedTags]);

    const handleSelectionChange = (selectedItems) => {
        setSelectedTags(selectedItems);
    };

	useEffect(() => {
		// Injecting CSS
		const style = document.createElement('style');
		style.innerHTML = `
		  .mapboxgl-popup-content {
			height: 410px;
		  }
		  
		  .mapboxgl-popup-tip {
			opacity: 0;
		  }
		`;
		
		// Append the style element to the head of the document
		document.head.appendChild(style);

		// Cleanup: Remove the style element when the component is unmounted
		return () => {
		  document.head.removeChild(style);
		};
	}, []);

	useEffect(() => {
	  if (typeof mapboxgl !== 'undefined') {
		mapboxgl.accessToken = 'pk.eyJ1IjoiY2hvc3Nsb3JlIiwiYSI6ImNrandna25ieDJ0aWoyeXFsNXJjenY4aHQifQ.xuhZZMoGCm5uCALqWiqFAQ';
		const map = new mapboxgl.Map({
		  container: 'map',
		  style: 'mapbox://styles/mapbox/dark-v11',
		  //style: 'mapbox://styles/mapbox-map-design/claitl3i0002715qm9990tl95',
		  center: [-149.995, 61.170],
		  zoom: 11,
		  pitch:60,
		  scrollZoom: false, 
		  boxZoom: false, 
		  dragRotate: false, 
		  keyboard: false,
		  doubleClickZoom: false, 
		  touchZoomRotate: false,
		  dragPan: false,
		});

	function rotateCamera(timestamp) {
	  map.rotateTo((timestamp / 200) % 360, { duration: 0 });
	  try {
          if (map.current) {
            map.current.resize();
			console.log("Resizin!")
          }
        } catch (error) {
          console.error("Error resizing the map during ResizeObserver:");
       }
	  map.setCenter([-149.995, 61.170]);
	  requestAnimationFrame(rotateCamera);
	}
	

    map.on('load', () => {	
		map.removeLayer('airport-label');
		
		map.loadImage(
            '/leader.png',
            (error, image) => {
                if (error) throw error;

                // Add the image to the map style.
                map.addImage('leader_line', image);
				
				map.addSource('point', {
					'type': 'geojson',
					'data': {
						'type': 'FeatureCollection',
						'features': [
							{
								// feature for Mapbox DC
								'type': 'Feature',
								'geometry': {
									'type': 'Point',
									'coordinates': [
										-149.995, 61.170 
									]
								},
								'properties': {
									'title': 'ANC - Ted Stevens'
								}
							}
						]
					}
				});
		
				map.addLayer({
					"id": "Labels",
					"type": "symbol",
					//"source": "Lyr_Polygon1",
					"source": "point",
					"minzoom": 4,
					"layout": {
						"symbol-placement": "point",
						"text-field": ['format',
                                    "ANC",
                                    { 'font-scale': 1.0,
                                    'text-offset': [0,-10]},
                                    ["concat",'\n', "Ted Stevens Int'l Airport"],
                                    {'font-scale': 0.8,
                                    'text-offset': [0,-0.2]},
                                ],
						"text-offset": [0, -9.7],
						"icon-image": 'leader_line',
						"icon-anchor": 'bottom',
					},
					"paint": {
						"text-color": "#60a5fa",
						"text-halo-color": "hsl(0, 0%, 3%)",
						"text-halo-width": 1,
						"text-halo-blur": 1
					  }
				});
		   }
        );
		
		map.addSource('perimeter', {
			'type': 'geojson',
			'data': {
				'type': 'FeatureCollection',
				'features': [
					{
						'type': 'Feature',
						//Manitoba Proper
						'properties': {
							'color': '#F7455D' // red
						},
						'geometry': {
							'type': 'Polygon',
							'coordinates': [[ 
							[ -150.0097, 61.2038 ], [ -150.0048, 61.2025 ], [ -149.9997, 61.2012 ], [ -149.9931, 61.1998 ], [ -149.9878, 61.1994 ], [ -149.9878, 61.1953 ], [ -149.968, 61.1953 ], [ -149.9714, 61.1917 ], [ -149.9653, 61.1917 ], [ -149.9653, 61.1881 ], [ -149.9578, 61.1881 ], [ -149.9578, 61.1808 ], [ -149.9539, 61.1808 ], [ -149.9538, 61.1807 ], [ -149.9537, 61.1807 ], [ -149.9538, 61.1806 ], [ -149.956, 61.1801 ], [ -149.9567, 61.1799 ], [ -149.9578, 61.1794 ], [ -149.9578, 61.1793 ], [ -149.9574, 61.1794 ], [ -149.9568, 61.1797 ], [ -149.9563, 61.1799 ], [ -149.9541, 61.1804 ], [ -149.9523, 61.1806 ], [ -149.9504, 61.1808 ], [ -149.9462, 61.1808 ], [ -149.9455, 61.1807 ], [ -149.9441, 61.1805 ], [ -149.9437, 61.1803 ], [ -149.9432, 61.1802 ], [ -149.942, 61.18 ], [ -149.9406, 61.1795 ], [ -149.9412, 61.1792 ], [ -149.9428, 61.1796 ], [ -149.9428, 61.1768 ], [ -149.9464, 61.1764 ], [ -149.947, 61.1763 ], [ -149.948, 61.176 ], [ -149.9494, 61.1753 ], [ -149.9502, 61.175 ], [ -149.9515, 61.1747 ], [ -149.9529, 61.1745 ], [ -149.9532, 61.1745 ], [ -149.9539, 61.1746 ], [ -149.9562, 61.175 ], [ -149.9569, 61.1751 ], [ -149.9578, 61.1751 ], [ -149.9578, 61.1749 ], [ -149.9567, 61.1748 ], [ -149.9555, 61.1746 ], [ -149.9554, 61.1743 ], [ -149.9578, 61.1743 ], [ -149.9578, 61.1741 ], [ -149.9551, 61.1741 ], [ -149.9551, 61.174 ], [ -149.9444, 61.174 ], [ -149.9441, 61.174 ], [ -149.9438, 61.1739 ], [ -149.9435, 61.1736 ], [ -149.9278, 61.1736 ], [ -149.9279, 61.1664 ], [ -149.9528, 61.1664 ], [ -149.9527, 61.1646 ], [ -149.9553, 61.164 ], [ -149.9559, 61.1641 ], [ -149.959, 61.1634 ], [ -149.9594, 61.1628 ], [ -149.96, 61.1628 ], [ -149.9604, 61.1625 ], [ -149.9604, 61.162 ], [ -149.9632, 61.162 ], [ -149.9639, 61.1623 ], [ -149.9643, 61.1626 ], [ -149.9642, 61.1626 ], [ -149.9638, 61.1624 ], [ -149.9632, 61.1624 ], [ -149.9632, 61.1628 ], [ -149.9618, 61.1628 ], [ -149.9618, 61.1631 ], [ -149.9614, 61.1631 ], [ -149.9614, 61.1628 ], [ -149.9605, 61.1628 ], [ -149.9605, 61.1631 ], [ -149.9603, 61.1631 ], [ -149.9601, 61.1631 ], [ -149.96, 61.1632 ], [ -149.96, 61.1633 ], [ -149.9601, 61.1633 ], [ -149.9603, 61.1633 ], [ -149.9606, 61.1633 ], [ -149.9658, 61.1633 ], [ -149.9658, 61.1646 ], [ -149.9657, 61.1647 ], [ -149.9658, 61.1648 ], [ -149.9661, 61.1648 ], [ -149.9662, 61.1647 ], [ -149.9661, 61.1646 ], [ -149.9669, 61.1646 ], [ -149.9669, 61.1593 ], [ -149.9694, 61.1593 ], [ -149.9694, 61.1592 ], [ -149.9669, 61.1592 ], [ -149.9669, 61.1589 ], [ -149.9697, 61.1589 ], [ -149.9697, 61.1588 ], [ -149.9714, 61.1588 ], [ -149.9714, 61.1589 ], [ -149.9751, 61.1589 ], [ -149.9751, 61.1556 ], [ -149.9814, 61.1556 ], [ -149.9815, 61.1557 ], [ -149.9816, 61.1557 ], [ -149.9816, 61.1556 ], [ -149.9893, 61.1556 ], [ -149.9893, 61.1592 ], [ -150.0026, 61.1592 ], [ -150.0062, 61.1556 ], [ -150.0117, 61.1556 ], [ -150.0118, 61.1592 ], [ -150.0267, 61.1592 ], [ -150.0267, 61.1628 ], [ -150.0631, 61.1628 ], [ -150.0696, 61.1627 ], [ -150.0665, 61.1664 ], [ -150.0475, 61.1664 ], [ -150.0475, 61.1694 ], [ -150.0401, 61.1722 ], [ -150.0401, 61.1736 ], [ -150.0326, 61.1736 ], [ -150.0326, 61.1809 ], [ -150.0188, 61.1809 ], [ -150.0188, 61.1953 ], [ -150.0176, 61.1953 ], [ -150.0177, 61.1989 ], [ -150.0248, 61.1989 ], [ -150.0223, 61.2025 ], [ -150.0217, 61.2029 ], [ -150.0194, 61.2037 ], [ -150.0159, 61.2045 ], [ -150.014, 61.2044 ], [ -150.0097, 61.2038 ]
							]]}
					}
				]
			}
		});

		map.addLayer({
			//This is for the zone dashed border
			'id': 'zonec',
			'type': 'fill',
			'source': 'perimeter',
			'paint': {
                    'fill-color': 'rgba(147,197,253, 0.3)'
                }
		});
		
		map.addLayer({
			//This is for the zone dashed border
			'id': 'zoneb',
			'type': 'line',
			'source': 'perimeter',
			'paint': {
			'line-width': 2,
			// Use a get expression (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-get)
			// to set the line-color to a feature property value.
			'line-color': '#60a5fa',
			'line-dasharray': [2, 1],
			}
		});

		map.addSource('mapbox-dem', {
			'type': 'raster-dem',
			'url': 'mapbox://mapbox.mapbox-terrain-dem-v1',
			'tileSize': 512,
			'maxzoom': 14
			});
			// add the DEM source as a terrain layer with exaggerated height
		map.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': 1.0 });

		map.on('mouseenter', 'zonec', function () {
			map.getCanvas().style.cursor = 'pointer';
		});
		
		map.on('mouseleave', 'zonec', function () {
			map.getCanvas().style.cursor = '';
		});
		
		map.on('click', 'zonec', function (e) {
			new mapboxgl.Popup({
				//className: "bg-blue-100",
				anchor: 'bottom',  // Anchor the popup to the bottom so it appears centered
				offset: [0, window.innerHeight / 4]  // Offset to center the popup vertically
			  })
			   .setHTML("<a href='https://www.windy.com/61.171/-149.998/meteogram?61.151,-149.896,12' style='color: #0000EE;' target='_blank'><u>Click to check weather<br>(external website)</u></a><br><br>Flight Tracker:<br><iframe id='myFrame' src='https://dot.ancairport.com/flights/' style='filter: xray; width: 200%; height: 600px; border: none; transform: scale(0.5); transform-origin: top left;'></iframe>")        
			   .setMaxWidth("250px")
				.setLngLat(map.getCenter())  // Set the popup's location to the clicked point
			  .addTo(map);
		});

		rotateCamera(0);
	});



		
		return () => map.remove(); // Clean up on unmount
	  }
	}, []);

	return (
			
		<div className='w-full h-full min-h-[83vh] md:min-h-[75vh] flex flex-grow relative'>
		  <div className='w-[30%] bg-blue-100 text-black flex flex-col items-center text-center p-6'>
			<span className="p-2 text-sm text-center">Click the airport for info...</span>
			<div id="map" className="w-11/12 md:w-4/5 lg:w-3/4 h-3/4 min-h-[650px] max-h-screen"></div>
		  </div>
		  <div className='w-[70%] bg-slate-100 text-black flex flex-grow flex-col items-center text-left pb-6'>
			<span className="p-6 pb-10 text-center">Here are some recent projects we're proud of. Are you facing any similar problems?</span>
			<CustomSelect options={bulletins} urlparam='items' trackparam={false} multiple onSelectionChange={handleSelectionChange} />
                <div className='min-h-4/5 w-4/5'>
                    {filteredBulletins.map((bulletin, index) => (
                        <div key={index} className="flex flex-initial w-full mb-1 p-4 bg-white text-black rounded shadow text-pretty break-words overflow-hidden">
							<img src={bulletin.img} className="w-1/4 aspect-square object-cover"/>
							<div className="w-3/4">
								<div className="relative flex items-center w-full">
									<h3 className="font-bold px-4">{bulletin.title}</h3>
									<div className="relative flex ml-auto">
										{bulletin.software.map((softwareLabel, idx) => {
											const softwareItem = software.find(item => item.label === softwareLabel);
											return softwareItem ? (
												<div key={idx} className="text-center relative px-1">
													<img src={softwareItem.url} alt={softwareLabel} className="w-12 h-12" />
													<p className="text-xs">{softwareLabel}</p>
												</div>
											) : null;
										})}
									</div>
								</div>
								<p className="text-wrap px-4 py-2">{renderTextWithLineBreaks(bulletin.text)}</p>
								{/*<p className="text-wrap px-4 py-2">{bulletin.text}</p>	*/}
								{/*<p className="text-sm text-gray-500 px-4 ">By {bulletin.author} on {new Date(bulletin.date_created).toLocaleDateString()}</p>	*/}
							</div>
                        </div>
                    ))}
                </div>
		  </div>
		</div>
	)

};

export default Portfolio;
